import React, { useState } from "react";
import { resumeLink } from "../../constants";

const Navbar = () => {
  const [activeLink, setActiveLink] = useState("home");
  // Menu Show
  const showMenu = (toggleId, navId) => {
    const toggle = document.getElementById(toggleId),
      nav = document.getElementById(navId);

    if (toggle && nav) {
      toggle.addEventListener("click", () => {
        nav.classList.toggle("show");
      });
    }
  };

  const handleActiveLink = (link) => {
    setActiveLink(link);
  };

  return (
    <div>
      <header className="l-header">
        <nav className="nav bd-grid">
          <div>
            <a href="/" className="nav-logo">
              {"< Manish Kumar />"}
            </a>
          </div>
          <div className="nav-menu" id="nav-menu">
            <ul className="nav-list">
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("home")}
              >
                <i className="bx bx-home"></i>
                <a
                  href="#home"
                  className={`nav-link ${
                    activeLink === "home" ? "active" : ""
                  }`}
                >
                  {" "}
                  Home
                </a>
              </li>
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("about")}
              >
                <i className="bx bx-user"></i>
                <a
                  href="#about"
                  className={`nav-link ${
                    activeLink === "about" ? "active" : ""
                  }`}
                >
                  About
                </a>
              </li>
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("skills")}
              >
                <i className="bx bx-code-alt"></i>
                <a
                  href="#skills"
                  className={`nav-link ${
                    activeLink === "skills" ? "active" : ""
                  }`}
                >
                  {" "}
                  Skills
                </a>
              </li>
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("projects")}
              >
                <i className="bx bx-window"></i>
                <a
                  href="#portfolio"
                  className={`nav-link ${
                    activeLink === "projects" ? "active" : ""
                  }`}
                >
                  Projects
                </a>
              </li>
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("contact")}
              >
                <i className="bx bx-user-circle"></i>
                <a
                  href="#contact"
                  className={`nav-link ${
                    activeLink === "contact" ? "active" : ""
                  }`}
                >
                  Contact
                </a>
              </li>
              <li
                className="nav-item center"
                onClick={() => handleActiveLink("resume")}
              >
                <i className="bx bxs-file-pdf"></i>
                <a
                  href={resumeLink}
                  target="_blank"
                  className={`nav-link ${
                    activeLink === "resume" ? "active" : ""
                  }`}
                  rel="noreferrer"
                >
                  Resume
                </a>
              </li>
            </ul>
          </div>
          <div
            className="nav-toggle"
            id="nav-toggle"
            onClick={() => showMenu("nav-toggle", "nav-menu")}
          >
            <i className="bx bx-menu"></i>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
